"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Text = _interopRequireDefault(require("./Text"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 *
 * @param {*} param0
 */
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    tip = _ref.tip,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$customStyle = _ref.customStyle,
    customStyle = _ref$customStyle === void 0 ? {} : _ref$customStyle,
    _ref$arrow = _ref.arrow,
    arrow = _ref$arrow === void 0 ? false : _ref$arrow,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'block' : _ref$display;
  if (!tip) {
    return children;
  }
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      customStyle: {
        padding: 8,
        lineHeight: 1.2
      },
      medium: true,
      color: "white"
    }, tip),
    placement: placement,
    arrow: arrow
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, customStyle), {}, {
      display: display
    })
  }, children));
};
var _default = exports["default"] = Tooltip;